/* global moment _ */
var getQueryStringParams = function () {
  var params = {}; var queryString; var queries; var temp; var i; var l
  // Split into key/value pairs
  queryString = window.location.search
  queryString = queryString.substring(1)
  queries = queryString.split('&')
  // Convert the array of strings into an object
  for (i = 0, l = queries.length; i < l; i++) {
    temp = queries[i].split('=')
    params[temp[0]] = temp[1]
  }
  return params
};

(function ($, baguetteBox) {
  $('html').removeClass('no-js').addClass('js')

  $(document).ready(function () {
    var win = $(window)

    $('#btnExpandMenu').on('click', function () {
      $('body').toggleClass('expanded')
    })

    window.lightboxes = baguetteBox.run('.o-lightbox', {
      noScrollbars: true,
      buttons: true,
      fullScreen: false
    })

    // Back to top Button
    // browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300
    // browser window scroll (in pixels) after which the "back to top" link opacity is reduced
    var offsetOpacity = 1200
    // duration of the top scrolling animation (in ms)
    var scrolTopDuration = 700
    // grab the "back to top" link
    var $backToTop = $('.cd-top')

    // hide or show the "back to top" link
    win.scroll(function () {
      ($(this).scrollTop() > offset) ? $backToTop.addClass('cd-is-visible') : $backToTop.removeClass('cd-is-visible cd-fade-out')
      if ($(this).scrollTop() > offsetOpacity) {
        $backToTop.addClass('cd-fade-out')
      }
    })

    // smooth scroll to top
    $backToTop.on('click', function (event) {
      event.preventDefault()
      $('body,html').animate({
        scrollTop: 0
      }, scrolTopDuration
      )
    })

    // with Isotope & jQuery
    // init Isotope
    //var $grid = $('#newsItemsContainer').isotope({
    //  layoutMode: 'masonry',
    //  itemSelector: '.c-art__item',
    //  percentPosition: true,
    //  masonry: {
    //    columnWidth: '.grid-sizer'
    //    // columnWidth: '50'
    //  }
    //})
    var $grid = $('#newsItemsContainer').isotope({
      layoutMode: 'fitRows',
      itemSelector: '.c-art__item',
      percentPosition: true
    })

    // layout Isotope after each image loads
    $grid.imagesLoaded().progress(function () {
      $grid.isotope('layout')
    })

    // Load more posts (news articles)
    var page = 1; var $btnMore = $('#btnMoreNews')
    $btnMore.click(function () {
      if ($btnMore.hasClass('c-btn--loading')) {
        return false
      }

      page++
      $btnMore.toggleClass('c-btn--loading')
      $btnMore.html('Laster...')
      var qsParams = getQueryStringParams()
      var year = (qsParams && qsParams.year) ? qsParams.year : moment().format('YYYY')

      $.ajax({
        url: '/api/v0/news/',
        type: 'GET',
        dataType: 'json',
        data: { year: year, page: page },
        success: function (results) {
          if (results && results.length > 0) {
            /* eslint no-multi-str: 0 */
            var compiled = _.template(' \
                            <% _.each(results, function(result) { %> \
                                <article class="col-md-4 c-art__item"> \
                                  <a href="<%= result.url %>" class="c-art__item-a"> \
                                    <img src="<%= result.mainImage %>" class="c-newslist__item-img"/> \
                                    <div class="c-art__item-head o-vertical-category"> \
                                      <div class="o-vertical-category__frame"> \
                                        <div class="c-art__toptitle o-vertical-category__label"><%= result.topTitle %></div> \
                                      </div> \
                                      <h3 class="c-art__item-title"><%= result.title %></h3> \
                                      <p class="c-art__item-text"><%= result.introText %></p> \
                                    </div> \
                                  </a> \
                                </article> \
                            <% }); %>')

            var $newItems = $(compiled({ results: results }))

            // Adds and lays out newly appended item elements to the end of the layout.
            $grid.append($newItems).isotope('appended', $newItems)

            $grid.imagesLoaded().progress(function () {
              $grid.isotope('layout')
            })
            $btnMore.toggleClass('c-btn--loading')
            $btnMore.html('Flere nyheter')
          } else {
            $btnMore.hide()
          }
        }
      })
    })
  })
})(window.$, window.baguetteBox)
